import {ModalController} from '@ionic/angular';
import {Component, EventEmitter, Input, Output} from '@angular/core';

import {DataTableOptions} from '@services';
import { FolderPanelSelectionType, IFolder, IPanelConfig } from '@modules/management/modules/folders/model/folders.interfaces';
import { FolderSearchModalComponent } from './modals/folder-search-modal/folder-search-modal.component';

@Component({
  selector: 'app-folder-search',
  templateUrl: './folder-search.component.html',
  styleUrls: ['./folder-search.component.scss'],
})
export class FolderSearchComponent {
  @Input() dataTableOptions: DataTableOptions;
  @Input() foldersList: IFolder[];
  @Input() folderUrl: string;
  @Input() tabTitle: string;
  @Input() panelConfig: IPanelConfig;
  @Input() setSelection: (ids: number[], type: FolderPanelSelectionType | null) => void;

  @Output() onCloseSearch: EventEmitter<void> = new EventEmitter<void>();

  constructor(private modalController: ModalController) {}

  private clearSelectionState() {
    (this.foldersList || []).forEach((folder: IFolder) => {
      folder.selected = false;
    });
    this.setSelection([], null);
  }

  async openSearchModal() {
    const modal = await this.modalController.create({
      component: FolderSearchModalComponent,
      componentProps: {
        dataTableOptions: this.dataTableOptions,
        foldersList: this.foldersList,
        folderUrl: this.folderUrl,
        panelConfig: this.panelConfig,
        tabTitle: this.tabTitle,
        setSelection: this.setSelection
      },
      cssClass: 'fullscreen-modal'
    });

    modal.present();

    modal.onDidDismiss().then(() => {
      this.clearSelectionState();
      this.onCloseSearch.emit();
    });
  }

}
